import React from 'react';
import { View } from 'react-native';
import { styled } from 'dripsy';
import { observer } from 'mobx-react-lite';

import { BaseText } from '../common/BaseText';
import { Touchable } from '../common/Touchable';
import { AvatarImage } from '../common/AvatarImage';
import { Separator } from '../common/Separator';
import type { Conversation } from '@models/Chats/ConversationModel';

const TouchableContainer = styled(Touchable)({
  backgroundColor: '$background0',
});

const RowContainer = styled(View)({
  flexDirection: 'row',
  alignItems: 'center',
});

const TextContainer = styled(View)({
  px: '$5',
  flexGrow: 1,
  flexShrink: 1,
});

const Title = styled(BaseText)({
  variant: 'text.medium',
  fontWeight: 'semi',
  color: '$heading800',
});

const MessageText = styled(BaseText)({
  variant: 'text.small',
  color: '$text400',
});

const CountContainer = styled(View)({
  size: 24,
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 12,
  bg: '$primary300',
});

const CountText = styled(BaseText)({
  variant: 'text.small',
  color: '$background0',
});

const CountPlaceholder = styled(View)({
  size: 24,
});

interface IConversationItemProps {
  item: Conversation;
  onPress(item: Conversation): void;
}

export const ConversationItem = observer(
  ({ item, onPress }: IConversationItemProps) => {
    return (
      <TouchableContainer onPress={() => onPress(item)}>
        <RowContainer>
          <AvatarImage
            size={52}
            source={{ uri: item.user?.photo.small?.url }}
          />

          <TextContainer>
            <Title numberOfLines={1}>{item.user.fullName}</Title>
            <Separator size="$2" />
            {!!item.lastMessage && (
              <MessageText numberOfLines={1}>
                {item.lastMessage}
              </MessageText>
            )}
          </TextContainer>

          {item.hasNewMessages ? (
            <CountContainer>
              <CountText>{item.formattedNewCount}</CountText>
            </CountContainer>
          ) : (
            <CountPlaceholder />
          )}
        </RowContainer>
      </TouchableContainer>
    );
  },
);
